import React, { Component, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import moment from 'moment'
import Pagination from '../../module/pagination-box'
import { noticeActions } from '../../store/actions'
import { connect } from 'react-redux'
import history from '../../route/history'
import { event } from 'jquery'
import notice from '../../store/reducers/notice/notice.reducer'

const NoticeList = (props) => {
  const queryString = require('query-string')
  const [state, setState] = useState({
    schCode: 'TITLE',
    schText: '',
    pageIdx: 0,
  })

  const [nowDate, setNowDate] = useState(new Date().toISOString().substr(0, 10).replace('T', ' '))

  const [pagingInfo, setPagingInfo] = useState({})

  useEffect(() => {
    const parsed = queryString.parse(props.search)
    parsed.schText && !parsed.schCode && (parsed.schCode = 'TITLE')
    setState(parsed)
    props.load(parsed)
  }, [props?.search])

  const handleChange = (e) => {
    const { name, value } = e.target

    setState({
      ...state,
      [name]: value,
    })
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      searchList()
    }
  }

  const searchList = (index = 0) => {
    let searchInfo = {}
    const { schCode, schText } = state
    schText?.length > 0 && (searchInfo = { schCode, schText })
    index > 0 && (searchInfo.pageIdx = index)

    setState({
      ...state,
    })

    let paramStr = queryString.stringify(searchInfo)
    paramStr.length > 0 && (paramStr = '?' + paramStr)
    history.push('/notice' + paramStr)
  }

  useEffect(() => {
    setPagingInfo({
      totalRecords: props.data?.totalElements ? props.data?.totalElements : 0,
      currentPage: state.pageIdx ? parseInt(state.pageIdx) + 1 : 1,
      pageNumber: props.data?.pageable?.pageNumber,
      pagesToShow: 5,
      totalPages: props.data?.totalPages,
    })
  }, [props.data])

  return (
    <React.Fragment>
      <div className="search-box center">
        <div className="row">
          <select title="검색타입" name="schCode" id="schCode" className="form-category3" value={state.schCode} onChange={handleChange}>
            <option value="TITLE">제목</option>
            <option value="CONTENT">내용</option>
            <option value="ALL">제목+내용</option>
          </select>
          <div className="inquiry-group">
            <input
              type="text"
              title="검색"
              className="form-keyword"
              placeholder="검색어를 입력하세요."
              id="schText"
              name="schText"
              value={state.schText || ''}
              onChange={handleChange}
              onKeyPress={handleKeyPress}
            />
            <button type="button" className="btn-search" onClick={searchList}>
              검색
            </button>
          </div>
        </div>
      </div>
      {props?.data?.content?.length == 0 ? (
        <div className="row noData">
          <div className="cell">등록된 자료가 없습니다.</div>
        </div>
      ) : (
        <React.Fragment>
          <div className="list-header">
            <span className="total-num">
              현재페이지 <em>{pagingInfo?.currentPage}</em>/{pagingInfo?.totalPages} {pagingInfo?.totalPage} {pagingInfo?.totalRecords}건
            </span>
          </div>
          <div className="pc-only">
            <div className="tbl-wrap">
              <table className="tbl-list">
                <caption>번호, 제목, 등록일, 조회 항목으로 구성</caption>
                <colgroup>
                  <col style={{ width: '8%' }} />
                  <col />
                  <col style={{ width: '10%' }} />
                  <col style={{ width: '10%' }} />
                </colgroup>
                <thead>
                  <tr>
                    <th scope="col">번호</th>
                    <th scope="col">제목</th>
                    <th scope="col">등록일</th>
                    <th scope="col">조회</th>
                  </tr>
                </thead>
                <tbody>
                  {props.data?.content?.map((notice, index) => {
                    return (
                      <tr key={index}>
                        <td data-title="번호">{notice.noticeSeq}</td>
                        <td data-title="제목" className="tleft">
                          <Link title="link" to={{ pathname: '/notice/' + notice.noticeSeq, state }}>
                            {String(nowDate) === String(moment(notice.regDt).format('YYYY-MM-DD')) ? (
                              <React.Fragment>
                                <i className="new">N</i>
                                <strong>{notice.noticeSj}</strong>
                              </React.Fragment>
                            ) : (
                              <span>{notice.noticeSj}</span>
                            )}
                            {notice.ptlFileDtoList?.length > 0 && <span className="file" />}
                          </Link>
                        </td>
                        <td data-title="등록일">{moment(notice.regDt).format('YYYY.MM.DD')}</td>
                        <td data-title="조회수">{notice.viewCount}</td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </div>

          <div className="mobile-only">
            <div className="list-view">
              {props.data?.content?.map((notice, index) => {
                return (
                  <Link key={index} title="link" to={{ pathname: '/notice/' + notice.noticeSeq, state }}>
                    <div className="row">
                      <div className="cell" data-title="번호">
                        {notice.noticeSeq}
                      </div>
                      <div data-title="제목" className="cell">
                        {String(nowDate) === String(moment(notice.regDt).format('YYYY-MM-DD')) ? (
                          <React.Fragment>
                            <i className="new">N</i>
                            <strong>{notice.noticeSj}</strong>
                          </React.Fragment>
                        ) : (
                          <span>{notice.noticeSj}</span>
                        )}
                        {notice.ptlFileDtoList?.length > 0 && <span className="file" />}
                      </div>
                      <div className="cell" data-title="등록일">
                        {moment(notice.regDt).format('YYYY.MM.DD')}
                      </div>
                      <div className="cell" data-title="조회수">
                        {notice.viewCount}
                      </div>
                    </div>
                  </Link>
                )
              })}
            </div>
          </div>
        </React.Fragment>
      )}
      <div className="list-footer">
        <Pagination pagingInfo={pagingInfo} onChange={(param) => searchList(param - 1)} />
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    data: state.notice?.data,
  }
}
const actionCreators = {
  load: noticeActions.load,
}

export default connect(mapStateToProps, actionCreators)(NoticeList)
